// Google Ads Conversion Tracking
//
// Como funciona:
//  - O snippet AdWords global precisa estar carregado (mesmo gtag.js do GA4)
//  - Cada conversao precisa do par {CONVERSION_ID, LABEL} criado no painel
//    Google Ads > Metas > Conversoes
//  - Quando os IDs sao preenchidos, o sistema dispara automaticamente
//  - Enquanto vazio, NAO dispara (sem-op silencioso) - seguro deploy em producao
//
// Para ativar:
//  1. Crie a acao de conversao em ads.google.com > Metas > Conversoes
//  2. Copie o Conversion ID (ex: AW-987654321) e o Label (ex: AbC-D_eFG)
//  3. Substitua os placeholders abaixo
//  4. Deploy
//
// Documentacao oficial:
//   https://support.google.com/google-ads/answer/7548399

// ⚠️ CONFIGURE AQUI ⚠️
// Conversion ID compartilhado por todas as acoes (formato AW-XXXXXXXXXX)
export const GOOGLE_ADS_CONVERSION_ID = '';

// Labels especificos de cada conversao (formato AbC-D_eFG)
// Cole o "Conversion Label" que aparece junto com o snippet no painel Ads
export const GOOGLE_ADS_LABELS = {
  signup: '',           // Cadastro / criar conta gratuita
  purchase: '',         // Compra confirmada (cliente assinou plano pago)
  checkout_started: '', // Inicio do checkout pago (opcional, util para remarketing)
  affiliate_signup: '', // Cadastro de afiliado (opcional)
};

export const isGoogleAdsEnabled = () =>
  Boolean(GOOGLE_ADS_CONVERSION_ID) && typeof window !== 'undefined';

/**
 * Dispara conversao para o Google Ads.
 *
 * @param {string} type - chave em GOOGLE_ADS_LABELS (signup, purchase, etc)
 * @param {object} [extra] - dados opcionais: { value: 39.90, currency: 'BRL', transaction_id: '...' }
 */
export function trackGoogleAdsConversion(type, extra = {}) {
  if (!isGoogleAdsEnabled()) return;
  const label = GOOGLE_ADS_LABELS[type];
  if (!label) return; // tipo nao configurado - silencioso

  try {
    if (window.gtag) {
      const payload = {
        send_to: `${GOOGLE_ADS_CONVERSION_ID}/${label}`,
        ...extra,
      };
      if (extra.value !== undefined && !payload.currency) {
        payload.currency = 'BRL';
      }
      window.gtag('event', 'conversion', payload);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[google-ads] conversao falhou:', e);
  }
}
